import React, { Children } from 'react';
import { BookOpenIcon, GiftIcon, CheckCircleIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-blue-50 py-10 md:py-16 px-6" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <h2 className="font-black text-4xl md:text-5xl text-center mb-12 text-[#1a1a2e]" data-id="element-142">
          Introducing: The "Screen-Free Kids" Protocol
        </h2>

        <p className="text-xl md:text-2xl text-center mb-12 font-semibold text-[#1a1a2e]" data-id="element-143">
          The 20-Minute Exit Strategy for Parents in Crisis.
        </p>

        <div className="flex justify-center mb-12" data-id="element-144">
          <div className="relative w-full md:w-3/4 lg:w-2/3 rounded-2xl overflow-hidden shadow-2xl" data-id="element-145">
            <img src="https://cdn.magicpatterns.com/uploads/keX36ScAzwp9zQLQzqZhXT/af401e2f-9d16-4e03-8ec9-fb8bf16d7c84.png" alt="Children Without Screens - Book and mobile preview" className="w-full h-auto object-cover" data-id="element-146" />
            {/* PDF Access Badge */}
            <div className="absolute top-4 right-4 bg-red-600 text-white font-black text-sm md:text-base px-4 py-2 rounded-full shadow-lg transform rotate-3 border-2 border-white" data-id="element-147">
              DIGITAL PDF ACCESS
            </div>
          </div>
        </div>

        <p className="text-lg md:text-xl text-center mb-8 text-[#1a1a2e]" data-id="element-148">
          This is a digital intervention kit designed to be read in 10 minutes
          and applied tonight.
        </p>

        <div className="bg-white rounded-xl shadow-lg p-6 md:p-10" data-id="element-149">
          <h3 className="font-bold text-2xl md:text-3xl mb-8 text-[#1a1a2e]" data-id="element-150">
            What's Inside:
          </h3>

          <div className="space-y-5" data-id="element-151">
            {/* Item 1 */}
            <div className="flex items-start gap-3" data-id="element-152">
              <CheckCircleIcon className="w-7 h-7 text-green-500 flex-shrink-0 mt-0.5" data-id="element-153" />
              <div data-id="element-154">
                <h4 className="font-bold text-lg md:text-xl text-[#1a1a2e]" data-id="element-155">
                  The 20-Minute Script
                </h4>
                <p className="text-base md:text-lg text-gray-700 mt-1" data-id="element-156">
                  Exactly what to say to "bridge" the dopamine gap before you
                  take the device.
                </p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="flex items-start gap-3" data-id="element-157">
              <CheckCircleIcon className="w-7 h-7 text-green-500 flex-shrink-0 mt-0.5" data-id="element-158" />
              <div data-id="element-159">
                <h4 className="font-bold text-lg md:text-xl text-[#1a1a2e]" data-id="element-160">
                  The Brain-Reset Method
                </h4>
                <p className="text-base md:text-lg text-gray-700 mt-1" data-id="element-161">
                  How to transition them from "iPad Mode" to "Family Mode"
                  without the chemical crash.
                </p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="flex items-start gap-3" data-id="element-162">
              <CheckCircleIcon className="w-7 h-7 text-green-500 flex-shrink-0 mt-0.5" data-id="element-163" />
              <div data-id="element-164">
                <h4 className="font-bold text-lg md:text-xl text-[#1a1a2e]" data-id="element-165">
                  The Focus-Back Habit
                </h4>
                <p className="text-base md:text-lg text-gray-700 mt-1" data-id="element-166">
                  A simple way to make them want to do homework before Roblox.
                </p>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t-2 border-dashed border-green-300 my-8" data-id="element-167"></div>

          {/* Bonuses Header */}
          <h3 className="font-black text-2xl md:text-3xl text-center text-green-600 mb-2" data-id="element-168">
            🎁 EXCLUSIVE BONUSES
          </h3>
          <p className="text-center text-gray-500 mb-8" data-id="element-169">
            Included FREE with your purchase today
          </p>

          <div className="space-y-5" data-id="element-170">
            {/* Bonus 1 */}
            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 relative overflow-hidden" data-id="element-171">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-black px-4 py-1 rounded-bl-lg" data-id="element-172">
                FREE
              </div>
              <div className="flex items-start gap-3" data-id="element-173">
                <CheckCircleIcon className="w-7 h-7 text-green-500 flex-shrink-0 mt-0.5" data-id="element-174" />
                <div data-id="element-175">
                  <div className="flex items-center gap-2 flex-wrap mb-1" data-id="element-176">
                    <GiftIcon className="w-5 h-5 text-green-600" data-id="element-177" />
                    <h4 className="font-bold text-lg md:text-xl text-[#1a1a2e]" data-id="element-178">
                      BONUS #1: Direct Access to the Creator
                    </h4>
                    <span className="text-base line-through text-gray-400" data-id="element-179">
                      $55.00
                    </span>
                  </div>
                  <p className="text-base md:text-lg text-gray-700 mt-2 leading-relaxed" data-id="element-180">
                    Get{' '}
                    <span className="font-bold text-green-600" data-id="element-181">
                      direct, personal access
                    </span>{' '}
                    to Daniel. Describe your situation and receive a{' '}
                    <span className="font-bold" data-id="element-182">
                      tailored response for your family
                    </span>
                    .
                  </p>
                </div>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 relative overflow-hidden" data-id="element-183">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-black px-4 py-1 rounded-bl-lg" data-id="element-184">
                FREE
              </div>
              <div className="flex items-start gap-3" data-id="element-185">
                <CheckCircleIcon className="w-7 h-7 text-green-500 flex-shrink-0 mt-0.5" data-id="element-186" />
                <div data-id="element-187">
                  <div className="flex items-center gap-2 flex-wrap mb-1" data-id="element-188">
                    <GiftIcon className="w-5 h-5 text-green-600" data-id="element-189" />
                    <h4 className="font-bold text-lg md:text-xl text-[#1a1a2e]" data-id="element-190">
                      BONUS #2: The "Reconnect" Guide
                    </h4>
                    <span className="text-base line-through text-gray-400" data-id="element-191">
                      $34.00
                    </span>
                  </div>
                  <p className="text-base md:text-lg text-gray-700 mt-2 leading-relaxed" data-id="element-192">
                    Once the screen is gone, the{' '}
                    <span className="font-bold" data-id="element-193">real work begins</span>.
                    Step-by-step strategies to{' '}
                    <span className="font-bold text-green-600" data-id="element-194">
                      rebuild trust and create new shared moments
                    </span>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}